<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Paramètres')
</script>

<template>
  <q-page flex> Paramètres </q-page>
</template>
